import { useMemo } from "react"
import { useParams } from "react-router-dom"
import Container from "../components/ui/Container.js"
import useFetch from "../hooks/useFetch.js"
import { api } from "../services/api/index.js"
import { Respuesta } from "../components/Respuesta"

import "./Consigna.scss"
import { useTranslation } from "react-i18next"

const SingleRespuestaView = ({ respuesta }) => {
  return (
    <>
      <Container>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col col-lg-5 col-12">
              <center className="mb-5 mt-4">
                <small>
                  Respuesta #{respuesta.respuesta_id} de la consigna
                </small>
                <h3>{respuesta.consigna.titulo}</h3>
              </center>
              <Respuesta respuesta={respuesta} />
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

const RespuestaView = () => {
  const { t } = useTranslation()
  const { con_id, res_id } = useParams()
  const { url, opt } = useMemo(
      () =>
        api.consignas.respuestas.readOne({
          con_id,
          res_id,
        }),
      [con_id, res_id]
    ),
    [respuesta, isPending, err] = useFetch({ url, opt })

  if (!con_id || !res_id) return <Container />

  if (isPending && !err)
    return (
      <>
        <Container>
          <center>{t("ui.btns.loading")}...</center>
        </Container>
      </>
    )

  return <SingleRespuestaView respuesta={respuesta} />
}

export default RespuestaView
